var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-results" },
    [
      _c("search-filter", {
        attrs: { searchTerm: _vm.searchTerm, searchLabel: _vm.searchLabel },
        on: {
          "update:searchTerm": function($event) {
            _vm.searchTerm = $event
          },
          "update:search-term": function($event) {
            _vm.searchTerm = $event
          },
          formSearch: _vm.submitSearch
        }
      }),
      _vm._v(" "),
      !_vm.initialLoad
        ? _c(
            "div",
            [
              _c("search-nav", {
                attrs: {
                  sites: _vm.sitesNav,
                  activeIndex: _vm.activeIndex,
                  searchDescription: _vm.searchDescription
                },
                on: { getResults: _vm.setSiteContent }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-results__container" },
                _vm._l(_vm.pageContent, function(page, index) {
                  return _c(
                    "search-page",
                    {
                      key: page.id,
                      attrs: {
                        isActive: _vm.activeIndex === index,
                        searchTerm: _vm.searchTerm,
                        totalResults: _vm.totalResults(page),
                        pageResults: _vm.pageResults(page),
                        documentResults: _vm.documentResults(page)
                      }
                    },
                    [
                      _c(
                        "search-tablist",
                        [
                          _c(
                            "search-tab",
                            {
                              attrs: {
                                name: "searchResultsPages",
                                panelSuffix: "Panel",
                                tabSuffix: "Tab",
                                isActive: _vm.isActiveTab(page),
                                title: "Pages",
                                resultsNumber: _vm.pageResults(page)
                              }
                            },
                            [
                              page.pages.results
                                ? _c("search-listing", {
                                    attrs: {
                                      siteUrl: _vm.sites[index].siteUrl,
                                      "item-component": "SearchItemPage",
                                      resultsListing: page.pages.results
                                    },
                                    on: {
                                      searchResultClick: _vm.handleSearchClick
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasResults(page.pages.results)
                                ? _c("search-paging", {
                                    attrs: {
                                      searchType: "pages",
                                      currentPage: page.pages.pageNumber,
                                      totalPages: page.pages.totalPages
                                    },
                                    on: {
                                      getResults: function(page, searchType) {
                                        return _vm.getSearchResults(
                                          page,
                                          searchType,
                                          _vm.sites[index]
                                        )
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              page.pages.errored
                                ? _c("search-error")
                                : _vm._e(),
                              _vm._v(" "),
                              !page.pages.errored &&
                              !_vm.hasResults(page.pages.results)
                                ? _c("search-no-results", {
                                    attrs: {
                                      searchType: "pages",
                                      searchTerm: _vm.searchTerm
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          page.documents
                            ? _c(
                                "search-tab",
                                {
                                  attrs: {
                                    name: "searchResultsDocuments",
                                    panelSuffix: "Panel",
                                    tabSuffix: "Tab",
                                    isActive: !_vm.isActiveTab(page),
                                    title: "Documents",
                                    resultsNumber: _vm.documentResults(page)
                                  }
                                },
                                [
                                  page.documents.results
                                    ? _c("search-listing", {
                                        attrs: {
                                          siteUrl: _vm.sites[index].siteUrl,
                                          "item-component": "SearchItemDoc",
                                          resultsListing: page.documents.results
                                        },
                                        on: {
                                          searchResultClick:
                                            _vm.handleSearchClick
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasResults(page.documents.results)
                                    ? _c("search-paging", {
                                        attrs: {
                                          searchType: "documents",
                                          currentPage:
                                            page.documents.pageNumber,
                                          totalPages: page.documents.totalPages
                                        },
                                        on: {
                                          getResults: function(
                                            page,
                                            searchType
                                          ) {
                                            return _vm.getSearchResults(
                                              page,
                                              searchType,
                                              _vm.sites[index]
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  page.documents.errored
                                    ? _c("search-error")
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !page.documents.errored &&
                                  !_vm.hasResults(page.documents.results)
                                    ? _c("search-no-results", {
                                        attrs: {
                                          searchType: "documents",
                                          searchTerm: _vm.searchTerm
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading ? _c("search-loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03b28908", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b28908","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/developers/results/SearchResults.vue
// module id = 544
// module chunks = 0